import { useEffect } from "react";

export default function useDisableRightClick(enabled = true) {
    useEffect(() => {
        if (!enabled) return;

        const handler = (e: MouseEvent) => e.preventDefault();
        document.addEventListener("contextmenu", handler);

        return () => document.removeEventListener("contextmenu", handler);
    }, [enabled]);
}
